import ImageX from "components/utility/images/ImageX";
import { DDXModal } from "components/ddx-modal/DDXModal";
import React, { useEffect, useRef } from "react";

interface TabcordionVideoModalProps {
	showModal: boolean;
	setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
	vid: string;
}

const TabcordionVideoModal = ({
	showModal,
	setShowModal,
	vid
}: React.PropsWithChildren<TabcordionVideoModalProps>) => {
	const tabcordionModalRef = useRef<HTMLDivElement>(null);

	const handleCloseModal = (e) => {
		if (e && e.type === "keydown" && ["Tab", "Shift"].includes(e.key)) return;
		setShowModal(false);
	};

	useEffect(() => {
		const handleResize = () => {
			const tabcordionModal = tabcordionModalRef.current;

			if (tabcordionModal) {
				setShowModal(tabcordionModal.checkVisibility());
			}
		};

		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, [setShowModal]);

	return (
		<DDXModal
			showModal={showModal}
			handleCloseModal={handleCloseModal}
			className="tabcordion--video-modal"
		>
			<div id="tabcordion-modal" ref={tabcordionModalRef}>
				<div
					className="modal-close-button"
					tabIndex={0}
					role="button"
					onKeyDown={handleCloseModal}
					onClick={handleCloseModal}
				>
					<ImageX />
				</div>
				<div className="tabcordion--video-content">
					<iframe
						className="tabcordion--video-iframe"
						width="100%"
						height="100%"
						title="Video Modal"
						src={vid}
						allowFullScreen
					/>
				</div>
			</div>
		</DDXModal>
	);
};

export default TabcordionVideoModal;
